import { useEffect } from 'react';
const useOutsideClick = (targets, callback, active = true) => {
    useEffect(() => {
        if (!active)
            return;
        const handleClickOutside = (event) => {
            const targetArray = Array.isArray(targets) ? targets : [targets];
            const outsideAdditionalTargets = !targetArray.find((el) => el !== null && el !== undefined && el.contains(event.target));
            if (outsideAdditionalTargets) {
                callback?.(event);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [targets, callback, active]);
};
export default useOutsideClick;
//# sourceMappingURL=UseOutsideClick.js.map